import { TextListOptionMenuOverview } from '@desygner/ui-editor-popup-menu';
import React from 'react';
import ReactAppBuilder from 'src/utils/react-app-builder';
import { text as config } from '@config';
import Store, { actions } from '@store';
import { fromUnicodeToString } from 'src/utils/format';

class BulletListOptionMenu extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
    this.editBulletPoints = null;
  }

  get labels () {
    return {
      levelTitle: INKIVE.TranslateHelper.translate('popupmenu.text_list_option_menu.level'),
      addLevel: INKIVE.TranslateHelper.translate('popupmenu.text_list_option_menu.add_new_level'),
      removeLevel: INKIVE.TranslateHelper.translate('popupmenu.text_list_option_menu.remove'),
      continueAcrossStories: INKIVE.TranslateHelper.translate('popupmenu.text_list_option_menu.continue_number_across_stories'),
      save: INKIVE.TranslateHelper.translate('popupmenu.text_list_option_menu.save'),
      cancel: INKIVE.TranslateHelper.translate('popupmenu.text_list_option_menu.cancel'),
      customBulletModalTitle: INKIVE.TranslateHelper.translate('popupmenu.text_list_option_menu.custom_bullet_modal_title')
    };
  }

  get options () {
    return config.bulletListOptionMenuOptions.map(option => ({
      ...option,
      isSelected: false
    }));
  }

  get symbols () {
    return config.customSymbols.map((symbol) => {
      return {
        value: symbol,
        label: fromUnicodeToString(symbol)
      };
    });
  }

  get bulletListFactory () {
    return INKIVE.BulletListFactory;
  }

  mountApp (editBulletPoints, selectedValues) {
    if (this.root) this.closeApp();

    const level = selectedValues?.length || config.textListOptionMenu.minLevel;
    const defaultOptionValue = this.options.map(option => option.value);
    const customOptions = selectedValues?.map(value => {
      if (defaultOptionValue.includes(value)) {
        return false;
      } else {
        return value;
      }
    });

    this.defaultOptions = Array(level).fill(this.options);
    customOptions?.forEach((value, index) => {
      if (!value) return;

      this.defaultOptions[index] = [...this.defaultOptions[index], {
        value,
        label: fromUnicodeToString(value),
        badge: {}
      }];
    });

    this.selectedValues = selectedValues?.map(value => value) || Array(level).fill(this.options[0].value);
    this.editBulletPoints = editBulletPoints;
    super.mountApp(this.App);
  }

  closeApp () {
    this.editBulletPoints = null;
    super.closeApp(this.App);
  }

  async onSave (values) {
    this.selectedValues = values;

    const selectedBulletStyle = Number(this.editBulletPoints.bulletStyle);
    const metadata = this.editBulletPoints.isEditing
      ? this.bulletListFactory.updateExistingMetadata(selectedBulletStyle, this.selectedValues)
      : this.bulletListFactory.createNewMetadata(this.selectedValues);

    await Store.dispatch(actions.text.setListStyle(metadata));

    this.editBulletPoints.render();
    INKIVE.hasEditorUnsavedChanges = true;
    this.closeApp();
  }

  App = () => {
    const props = {
      variant: 'bullet-list',
      minLevel: config.textListOptionMenu.minLevel,
      maxLevel: config.textListOptionMenu.maxLevel,
      defaultOptions: this.defaultOptions,
      selectedValues: this.selectedValues,
      acrossStories: false,
      labels: this.labels,
      symbols: this.symbols,
      onSave: this.onSave.bind(this),
      onCancel: this.closeApp.bind(this)
    };

    return <TextListOptionMenuOverview {...props} />;
  };
}

export default new BulletListOptionMenu({
  appId: 'react-bullet-list-option-menu-app',
  targetNodeSelector: 'div.edit-bullet-points'
});
